/* Shared, side-effect-free order rules. Server must independently enforce the same catalog. */
((root) => {
  const catalog = Object.freeze({ chair: 444900, ravza: 85000 });
  const clean = (value) => String(value || '').trim();
  const phone = (value) => {
    let digits = clean(value).replace(/\D/g, '');
    if (digits.length === 12 && digits.startsWith('90')) digits = digits.slice(2);
    if (digits.length === 11 && digits.startsWith('0')) digits = digits.slice(1);
    return /^5\d{9}$/.test(digits) ? `+90${digits}` : '';
  };
  const discount = (accepted) => accepted === true ? 22245 : 0;
  const total = (upsell, accepted = false) => catalog.chair + (upsell ? catalog.ravza : 0) - discount(accepted);
  const format = (cents) => `${new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 2 }).format(cents / 100)} TL`;
  const validate = (values, cities) => {
    const errors = {};
    if (!clean(values.first_name) || clean(values.first_name).length > 60) errors.first_name = 'Lütfen adınızı girin.';
    if (!clean(values.last_name) || clean(values.last_name).length > 60) errors.last_name = 'Lütfen soyadınızı girin.';
    if (!phone(values.phone)) errors.phone = '05XX XXX XX XX biçiminde geçerli bir cep telefonu girin.';
    if (!Object.hasOwn(cities, values.il)) errors.il = 'Lütfen ilinizi seçin.';
    if (!Object.hasOwn(cities, values.il) || !cities[values.il].includes(values.ilce)) errors.ilce = 'Lütfen seçtiğiniz ile ait ilçeyi seçin.';
    if (clean(values.address).length < 10 || clean(values.address).length > 500) errors.address = 'Mahalle, sokak, bina ve daire bilgilerini içeren adresinizi girin.';
    if (clean(values.note).length > 300) errors.note = 'Not en fazla 300 karakter olabilir.';
    if (values.payment_method !== 'cash_or_card') errors.payment_method = 'Kapıda ödeme bilgisi geçersiz.';
    return errors;
  };
  const buildPayload = (values, eventId) => ({
    schema_version: values.exit_offer === true ? 'kiblem-cod-exit5-v1' : 'kiblem-cod-v1', event_id: eventId, created_at: new Date().toISOString(),
    payment: 'cod', payment_method: values.payment_method, currency: 'TRY',
    value: total(values.upsell, values.exit_offer) / 100, total_minor: total(values.upsell, values.exit_offer), shipping_minor: 0,
    items: [{ sku: 'KIBLEM-CHAIR', quantity: 1, unit_price_minor: catalog.chair }, ...(values.upsell ? [{ sku: 'KIBLEM-RAVZA', quantity: 1, unit_price_minor: catalog.ravza }] : [])],
    customer: { first_name: clean(values.first_name), last_name: clean(values.last_name), phone: phone(values.phone), il: values.il, ilce: values.ilce, address: clean(values.address), note: clean(values.note) }
  });
  root.KiblemCodCore = Object.freeze({ catalog, discount, phone, total, format, validate, buildPayload });
})(typeof window === 'undefined' ? globalThis : window);
